/**
 * Block registry. Iteration order = order in the editor's block palette.
 * Adding a new block: define it in its own file, then add it here.
 */

import type { BlockDefinition, BlockType } from '../types';
import { avatar } from './avatar';
import { heading } from './heading';
import { paragraph } from './paragraph';
import { linkButton } from './link-button';
import { socialRow } from './social-row';
import { image } from './image';
import { divider } from './divider';
import { countdown } from './countdown';
import { stockPill } from './stock-pill';
import { videoEmbed } from './video-embed';
import { stickyCta } from './sticky-cta';
import { linkList } from './link-list';
import { carousel } from './carousel';
import { liveStatus } from './live-status';
import { instagramBio } from './instagram-bio';
import { spacer } from './spacer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const REGISTRY: Record<BlockType, BlockDefinition<any>> = {
  avatar,
  heading,
  paragraph,
  'link-button': linkButton,
  'social-row': socialRow,
  image,
  divider,
  countdown,
  'stock-pill': stockPill,
  'video-embed': videoEmbed,
  'sticky-cta': stickyCta,
  'link-list': linkList,
  carousel,
  'live-status': liveStatus,
  'instagram-bio': instagramBio,
  spacer,
};

export const BLOCK_REGISTRY = REGISTRY;

export const BLOCK_TYPES: BlockType[] = [
  'instagram-bio',
  'avatar',
  'live-status',
  'heading',
  'paragraph',
  'link-button',
  'link-list',
  'sticky-cta',
  'social-row',
  'image',
  'carousel',
  'video-embed',
  'countdown',
  'stock-pill',
  'spacer',
  'divider',
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getBlockDef(type: BlockType): BlockDefinition<any> | null {
  return REGISTRY[type] ?? null;
}
